import { PositionsService } from "~/entity/Positions/api/service";

export const usePositions = () => {
  const positionsGet = PositionsService.GET.getPositions;
  const positionGetById = PositionsService.GET.getPositionById;
  const positionCreate = PositionsService.POST.createPosition;
  const positionPut = PositionsService.PUT.putPosition;

  return {
    positionsGet,
    positionGetById,
    positionCreate,
    positionPut,
  };
};
